import { ReactNode } from "react";
import cx from "classnames";
import { InteractiveContainer, Tooltip } from "@jugl-web/ui-kit";
import { AvailableTool } from "../../tools/Tool";
import useEditorContext from "../useEditorContext";

export type ToolbarActionName =
  | "preview"
  | "crop"
  | "brush"
  | "text"
  | "delete";

export interface Action {
  name: ToolbarActionName;
  tooltip: string;
  icon: ReactNode;
  tool: AvailableTool;
  disabled: boolean;
  toolkit: ReactNode | null;
}

interface ComponentProps {
  action: Action;
}

const ToolbarAction = ({ action }: ComponentProps) => {
  const { activeTool, setActiveTool } = useEditorContext();

  const isActive = activeTool === action.name;
  const isDisabled = action.disabled;

  return (
    <Tooltip
      className="!z-[1300]"
      placement="top"
      renderTrigger={({ props, ref }) => (
        <InteractiveContainer
          ref={ref}
          {...props}
          className={cx(
            "flex h-10 w-10 items-center justify-center border-none bg-transparent text-white",
            {
              "cursor-default rounded bg-white/5": isActive,
              "cursor-pointer rounded transition-opacity duration-150 hover:opacity-80":
                !isActive && !isDisabled,
              "cursor-not-allowed opacity-10": isDisabled,
            }
          )}
          onClick={() => {
            setActiveTool(action.name, action.tool);
          }}
          isDisabled={isDisabled}
        >
          {action.icon}
        </InteractiveContainer>
      )}
    >
      {action.tooltip}
    </Tooltip>
  );
};

export default ToolbarAction;
